import { transaction, values } from 'mobx';
import Tag from '../../pages/Transactions/Tag';
import { observer } from 'mobx-react';
import { transactionStore, userStore } from '../../stores';
import React, { useState, useMemo } from 'react';
import { amountFormatter } from '../../utils/utils';
import { InvoiceController, TransactionsController } from '../../controllers';
import constant from '../../utils/constant';
import { MimaToastUtil } from '../../components';
import moment from 'moment';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const TagContainer = ({ closeModal, setShowSurvey }) => {
	const [loading, setLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(0);
	const [limit, setLimit] = useState(50);

	const { needFeedback } = useGetAllActiveReviews(
		constant.FEEDBACK.TRANSACTIONSTAG
	);

	const selectedIncome = transactionStore.selectedIncome;
	const onCloseModal = () => {
		closeModal();
		transactionStore.setSelectedIncome({});
		transactionStore.setTag({});
	};

	const invoiceTableQuery = useMemo(() => {
		return `offset=${currentPage + 1}&limit=${limit}`;
	}, [currentPage, limit]);

	const { data } = InvoiceController.useInvoiceList(invoiceTableQuery);

	const invoiceList = useMemo(() => {
		if (data?.status === constant.Success) {
			return data?.data?.value?.invoices || [];
		}
		return [];
	}, [data]);

	const tags = [
		{
			key: 'Income',
			value: 'Payment For Goods/Services',
		},
		{
			key: 'Refund',
			value: 'Refund/Reversal',
		},
		{
			key: 'Funding',
			value: 'Wallet Funding',
		},
		{
			key: 'Loan',
			value: 'Loan',
		},
		{
			key: 'Investment',
			value: 'Investment',
		},
		{
			key: 'Gifts',
			value: 'Gifts And Donations',
		},
		{
			key: 'Assets',
			value: 'Sales Of Business Properties',
		},
	];

	const invoiceDetailsList = invoiceList
		.filter(x => x.parentInvoice === undefined)
		.map(y => {
			return {
				key: y._id,
				value: `${moment(y.createdAt).format('DD/MM/YYYY h:mm a')}-INV-${y.number} ${y.customer?.fullname} - ${amountFormatter(y.currencyCode).format(y.deposit)}`,
			};
		});

	const balInvoiceList = invoiceList
		.filter(x => x.parentInvoice)
		.map(y => {
			return {
				key: y._id,
				value: `${moment(y.createdAt).format('DD/MM/YYYY h:mm a')}-INV-${y.number} ${y.customer?.fullname} - ${amountFormatter(y.currencyCode).format(y.deposit)}`,
			};
		});

	const onSubmit = async values => {
		setLoading(true);
		const payload = {
			inflowType: values.inflowType,
			invoiceId: values.invoiceId ? values.invoiceId : transactionStore.tag._id,
		};
		const { status, errorMessage } = await TransactionsController.tagIncome(
			payload,
			transactionStore.tag._id
		);
		setLoading(false);
		if (status === constant.Success) {
			TransactionsController.transactions();
			MimaToastUtil.success({
				message: constant.Success,
			});
			onCloseModal();
			if (needFeedback._id) {
				setShowSurvey(true);
				userStore.setReviewId(needFeedback._id);
			}
			return;
		}
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<Tag
			closeModal={onCloseModal}
			selectedIncome={selectedIncome}
			loading={loading}
			tags={tags}
			invoiceDetailsList={invoiceDetailsList}
			balInvoiceList={balInvoiceList}
			onSubmit={onSubmit}
		/>
	);
};
export default observer(TagContainer);
